import React from "react";
import { PageContainer, PageHeader, PageContent } from "../../components/Layout";
import { Switch, Button, message, Spin } from "antd";
import { role as roleApi } from "../../apis";
import { SaveOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import MyTable from "../../components/MyTable";
import styled from "styled-components";
import { useTranslate } from "../../hooks";

export default () => {
  const { translate } = useTranslate();
  const myTableRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const { isMobile, permissions } = useSelector(state => state.general);
  const [data, setFormData] = React.useState([]);

  const onChange = (value) => {
    setFormData(state => ([...state.filter(p => !(p.code === value.code && p.role === value.role)), value]));
  };

  const onSubmit = async () => {
    setLoading(true);
    try {
      await roleApi.update(data);

      message.success(translate("system.request.success", "Success!"));
    } catch (err) {
      message.error(err?.message || translate("system.request.error", "Error!"));
    }

    setLoading(false);
  };

  const loadData = async () => {
    let res = await roleApi.get();

    setFormData(res);
  };

  React.useEffect(() => {
    loadData();
  }, []);

  const columns = useHeader({ permissions: data, onChange, translate });

  return (
    <PageContainer>
      <PageHeader title={translate("user.role.pageheader.title", "User role")} extra={[<Button icon={<SaveOutlined />} type="primary" shape={isMobile&&"circle"} loading={loading} onClick={() => { onSubmit(); }}>{!isMobile && translate("user.role.btn.save", "Save") }</Button> ]}/>
      <PageContent style={{ paddingBottom: "40px" }}>
        <Spin spinning={loading} >
          <Table
            scroll={{ x: "100px" } }
            bordered={false}
            ref={myTableRef}
            pagination={false}
            columns={columns}
            dataSource={permissions}
            rowKey={(record) => record?.id} />
        </Spin>
      </PageContent>
    </PageContainer>
  );
};

const useHeader = ({ permissions, onChange, translate }) => {
  return [{
    title : translate("system.useheader.title.name", "Name"),
    render: (record) => {
      if (record?.type === "GROUP") {
        return (<div style={{ fontWeight: "bold" }}>{record.name}</div>);
      }
      return (<div >{record?.name}</div>);
    }
  }, {
    title : <Title>{translate("user.role.useheader.admin", "Admin")}</Title>,
    render: (record) => {
      if (record.type === "GROUP") return;
      return (
        <Permission>
          <Switch checked={permissions.find(p => p.code === record.code && p.role === "ADMIN" && p.isAccept === true)}
            onChange={(e) => onChange({
              code    : record.code,
              role    : "ADMIN",
              isAccept: e
            })} />
        </Permission>
      );
    }
  }, {
    title : <Title>{translate("user.role.useheader.manager", "Manager")}</Title>,
    render: (record) => {
      if (record.type === "GROUP") return;

      return (
        <Permission>
          <Switch checked={permissions.find(p => p.code === record.code && p.role === "MANAGER" && p.isAccept === true)}
            onChange={(e) => onChange({
              code    : record.code,
              role    : "MANAGER",
              isAccept: e
            })} />
        </Permission>
      );
    }
  }, {
    title : <Title>{translate("user.role.useheader.operator", "Operator")}</Title>,
    render: (record) => {
      if (record.type === "GROUP") return;

      return (
        <Permission>
          <Switch checked={permissions.find(p => p.code === record.code && p.role === "OPERATOR" && p.isAccept === true)}
            onChange={(e) => onChange({
              code    : record.code,
              role    : "OPERATOR",
              isAccept: e
            })} />
        </Permission>
      );
    }
  }];
};

const Table = styled(MyTable)`
  .ant-table-thead > tr > th {    
    white-space: nowrap !important;
    padding: 0 !important;
    width: 220px; 
    
  .text-center {
    text-align: center;
  }

   &:first-child { 
    width: auto;
    min-width: 220px;
    text-align: center;
   }
   &:last-child {
     text-align: center;
   }
  }
  .ant-table-cell {  
   &:last-child { 
    width: 220px;  
    text-align: center;
   } 
  }
`;

const Title = styled.div`
  text-align: center;
  min-width: 220px;
  max-width: 220px;
  padding: 4px 8px;
`;


const Permission = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .ant-checkbox-wrapper {
    margin-right: 10px;
  }
  .ant-select {
    width: 160px;
  }
`;